import { SECTION_LABELS } from "./constants";

const TourProgressBar = ({ sectionIndex, progress, isPaused, onPause, onResume, onExit }) => {
  return (
    <div className="et-progress">
      <div className="et-progress__bar">
        <div className="et-progress__fill" style={{ width: `${progress}%` }} />
      </div>

      <div className="et-progress__info">
        {/* Section dots */}
        <div className="et-progress__sections">
          {SECTION_LABELS.map((label, idx) => (
            <div
              key={idx}
              className={`et-progress__dot ${
                idx < sectionIndex
                  ? "et-progress__dot--done"
                  : idx === sectionIndex
                  ? "et-progress__dot--active"
                  : ""
              }`}
              title={label}
            />
          ))}
        </div>

        {/* Current section label */}
        <span className="et-progress__label">
          {SECTION_LABELS[sectionIndex] || ""}
        </span>

        {/* Controls */}
        <div className="et-progress__controls">
          <button
            className="et-progress__btn"
            onClick={isPaused ? onResume : onPause}
            title={isPaused ? "Resume" : "Pause"}
          >
            {isPaused ? "\u25B6" : "\u275A\u275A"}
          </button>
          <button className="et-progress__btn et-progress__btn--exit" onClick={onExit} title="Exit tour">
            {"\u2715"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TourProgressBar;
